import { SimplePage } from "@/app/_/marketing/SimplePage";
import { HotkeysFeature } from "@/app/_/sections/3FeaturesSection/HotkeysFeature";
import { Navigation } from "@/constants";

export default function Page() {
  return (
    <SimplePage
      eyebrow="Triage & review"
      title="An inbox built for transaction review."
      subtitle="Uncategorized bank activity, pending changes, and items that need a human decision surface in one focused queue. Review, categorize, and reconcile without hunting through spreadsheets."
      secondaryCta={{
        label: "See it in action",
        to: Navigation.ROUTES.AUTH.WAITLIST,
      }}
      screenshot={{
        imageName: "triage-reconcile",
        alt: "The triage queue with a proposed receipt match",
      }}
      capabilities={[
        {
          title: "One queue for every entity.",
          description:
            "New bank activity from every company lands in a single list, labelled by entity and account, newest first.",
          imageName: "crop-triage-list",
        },
        {
          title: "Every transaction, already matched.",
          description:
            "Receipts, bills, and categories arrive pre-matched with the evidence — amount, contact, date — so you confirm instead of search.",
          imageName: "crop-triage-suggestion",
        },
        {
          title: "Never leave the keyboard.",
          description:
            "Arrow through the queue and ⌘K to categorize, tag, hold, or match. The next item is already waiting.",
          imageName: "crop-command-palette",
        },
      ]}
      illustration={{
        title: "Built for flow.",
        description:
          "Every action has a shortcut, so working through a month of activity feels like clearing an inbox.",
        render: () => HotkeysFeature().center.renderChildren(),
      }}
      bullets={Navigation.PLATFORM_ITEMS.filter((item) =>
        ["/platform/agents", "/platform/ledger"].includes(item.path),
      ).map((item) => ({
        ReactIcon: item.ReactIcon,
        name: item.name,
        tagline: item.tagline,
        to: item.path,
      }))}
    />
  );
}
